// import Store from 'store/store';
import parseQueryString from 'utils/parseQueryString';
import pendingPromise from 'utils/pendingPromise';

const qs = parseQueryString();
export const previewMode = qs.contentUpdatePreview;

if (typeof window !== 'undefined' && previewMode) {
	const allowedOrigins = ['https://cms.powster.com', 'http://localhost:4010', 'https://demo.pow.io'];
	window.addEventListener('message', e => {
		if (!allowedOrigins.includes(e.origin)) return;
		let message = e.data;
		if (message?.type === 'data' && previewDataWaitlist[message.file]) {
			previewDataWaitlist[message.file].forEach(p => p.resolve(message.data));
			previewDataWaitlist[message.file] = [];
		}
	}, false);
}

let previewDataWaitlist = {};
async function waitForPreviewData(file) {
	let promise = pendingPromise();
	if (!previewDataWaitlist[file]) {
		previewDataWaitlist[file] = [];
	}
	previewDataWaitlist[file].push(promise);
	return promise;
}

async function _load(file) {
	if (previewMode && window.parent !== window) {
		// Could use https://cms.powster.com instead of '*'
		window.parent.postMessage({ type: 'requestData', file }, '*');
		let data = await waitForPreviewData(file);
		return data;
	}
	try {
		let url = 'https://dx35vtwkllhj9.cloudfront.net/' + __STUDIO__ + '/' + __TITLE__ + '/dynamic/' + __REGION__ + '/' + file + '.json';
		let res = await fetch(url, { cache: 'no-cache' });
		let fileContent = await res.json();
		return fileContent.data;
		// if (fileContent.at > window.__BUILD_DATE__) {
		// 	return fileContent.data;
		// }
	} catch (err) {}
	return null;
}

const cache = {};
export function getDynamicData(file = 'main') {
	if (cache[file]) {
		return cache[file];
	}
	return cache[file] = _load(file);
}